__webpack_require__.p = "/yomawari/lost-in-the-dark/";